// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__J9KwS","Header__image":"header_Header__image__gVlyD","Header__text":"header_Header__text__YNBwz"};